import { render, staticRenderFns } from "./OrganizationsReportingChart.vue?vue&type=template&id=304dfcd2&"
import script from "./OrganizationsReportingChart.vue?vue&type=script&lang=ts&"
export * from "./OrganizationsReportingChart.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationsReportingChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports